<ng-container *transloco="let t">
  <div
    class="flex h-dvh w-full overflow-hidden bg-surface-50 text-surface-700 dark:bg-surface-950 dark:text-surface-100"
  >
    @if (isDesktopNavigationOpen()) {
      <aside
        class="sidebar hidden md:flex md:flex-col p-6"
        style="
          width: var(--default-layout-nav-width);
          min-width: var(--default-layout-nav-width);
          max-width: var(--default-layout-nav-width);
        "
      >
        <div class="flex items-center gap-3 mb-8">
          <div class="sidebar-icon-wrapper">
            <ng-icon name="heroArchiveBox" class="text-2xl" />
          </div>
          <h1 class="sidebar-title">Speed</h1>
        </div>
        <div class="flex-1 overflow-y-auto">
          <app-default-layout-navigation />
        </div>
        <app-user-profile />
      </aside>
    }

    <div class="flex min-h-0 min-w-0 flex-1 flex-col">
      <header
        class="relative z-10 flex h-16 shrink-0 items-center gap-3 border-b border-surface-200 bg-surface-0 px-4 dark:border-surface-800 dark:bg-surface-900/60 md:px-6"
      >
        <p-button
          class="md:hidden"
          type="button"
          icon="pi pi-bars"
          [label]="t('layout.default.header.menu')"
          severity="secondary"
          size="small"
          (click)="openMobileNavigation()"
        ></p-button>
        <div class="flex w-full items-center justify-end gap-2">
          <app-user-profile class="md:hidden" [compact]="true" />
          <pt-language-selector />
          <pt-theme-switcher />
        </div>


      </header>

      <main class="flex min-h-0 flex-1 flex-col overflow-y-auto bg-surface-0 dark:bg-surface-950">
        <router-outlet />
      </main>

      <footer
        class="flex h-12 shrink-0 items-center border-t border-surface-200 bg-surface-0 px-4 text-xs font-medium text-surface-500 dark:border-surface-800 dark:bg-surface-900/60 dark:text-surface-400 md:px-6"
      >
        {{ t('layout.default.footer.copyright', { year: currentYear }) }}
      </footer>
    </div>
  </div>

  <p-drawer
    [visible]="isMobileNavigationOpen()"
    [position]="'left'"
    [modal]="true"
    [dismissible]="true"
    [closable]="true"
    [ariaCloseLabel]="t('layout.default.header.closeNavigation')"
    [pt]="mobileDrawerPassThrough"
    [style]="{ width: 'var(--default-layout-nav-width)' }"
    (visibleChange)="setMobileNavigationVisibility($event)"
  >
    <div class="flex h-full flex-col p-6">
      <div class="flex-1 overflow-y-auto">
        <app-default-layout-navigation />
      </div>
      <app-user-profile />
    </div>
  </p-drawer>
</ng-container>
